import { render } from "./ProductRegist.vue?vue&type=template&id=d3dd3fb0&scoped=true"
import script from "./ProductRegist.vue?vue&type=script&lang=js"
export * from "./ProductRegist.vue?vue&type=script&lang=js"

import "./ProductRegist.vue?vue&type=style&index=0&id=d3dd3fb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3dd3fb0"]])

export default __exports__